export default __webpack_public_path__ + "static/media/238.6b752ed7.jpg";